import './cardModifyLimitView.scss';

import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';

import * as cardModifyNewLimitActions from 'actions/cardModifyNewLimit/cardModifyNewLimit';
import * as hireNewCreditCardActions from 'actions/hireNewCreditCard';
import * as hireInformationActions from 'actions/hireInformation';

import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKLink } from 'commonsComponents/OKLink';

import AccessHelper from 'utilities/accessHelper';
import { PAGE_GENERIC, recordPath } from 'utilities/tagging';
import { cardConstants } from 'utilities/accessHelperConditions/cards';
import { recordLink, recordLinkV2 } from 'utilities/tagging';

import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import { ModifyNewLimitStep1 } from 'components/cards/cardModifyLimitSteps/modifyLimitStep1/modifyNewLimitStep1';
import { ModifyNewLimitStep3 } from 'components/cards/cardModifyLimitSteps/modifyLimitStep3/modifyNewLimitStep3';
import ModifyLimitSuccessStep from 'components/cards/cardModifyLimitSteps/modifyLimitSuccessStep/modifyLimitSuccessStep';
import ModifyLimitErrorStep from 'components/cards/cardModifyLimitSteps/modifyLimitErrorStep/modifyLimitErrorStep';
import { HireCardOpenCreditStepINEDIR } from 'components/hire/cardINEDIRDocument/hireCardOpenCreditStepINEDIR';
import TutorialLauncher from 'components/tutorial/tutorialLauncher';
import { LoadingSection } from 'commonsComponents/loadingSection';
import CardHeaderDetails from 'components/cards/cardHeaderDetails/cardHeaderDetails';
import { GRAPHIC_TUTOR_TYPE_4, FIRST_STEP, YES_ACCEPTED, NOT_MAX_LIMIT } from 'constants/index';
import { CREDIT_CARD_REVOLVING_PROCESS } from 'constants/flagBasedFeatures';
import { getCardData } from '../hireNewCreditCardView/hireNewCreditCardViewUtilities';
import { LINK_CLICK_ACTION_EVENT } from 'constants/tagging';
import { getPlacementIdCard } from '../hireNewCreditCardView/hireNewCreditCardViewUtilities';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import {
    VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS_CC,
    NERUDA_CARD_PRODUCT_ALIAS_CC,
    VANITY_CARD_PRODUCT_ALIAS_CC,
    VIA_T_CARD_PRODUCT_ALIAS_CC,
    DIAMOND_CARD_PRODUCT_ALIAS_CC,
    OPEN_CREDIT_PRODUCT_ALIAS_CC
} from 'constants/hiringProductInformation';
import { catalogue, analyticsId, getCustomTags } from './cardModifyLimitAnalytics/cardModifyLimitAnalytics';
import { 
    PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT,
} from 'constants/tagging';

const CardModifyNewLimitView = (props) => {
    const { match: { params: { cardId } },
        immCards,
        history,
        requestLimits,
        clearRequest,
        redirect,
        buttonText,
        immCardModifyLimit,
        immFlagBasedFeatures,
        immProfile,
        validateStep,
        setVisibleStep,
        setWillCancel,
        handleAgreementCheckboxChange,
        documentRead,
        getNewCreditCardData,
        immHirePaymentMethod,
        onAcceptAllDocument,
        saveDocumentList,
        checkRadioButtonIneDir,
        modifyLimit,
        immPrinter,
        getHireInformation,
        onHandleChangeCheckBoxCC,
        immHireCreditLimit
    } = props
    const { formatText, getFinalTitle, FormattedText, hasTranslation } = i18n;
    const immCard = immCards.getIn(['byId', cardId]);
    const type = immCard.get('type');
    const subtitleLeft = formatText(`cards-${type}`);
    const subtitleRight = immCard.get('alias').get('current');
    const typeCode = immCard.getIn(['product', 'type']);
    const subtypeCode = immCard.getIn(['product', 'subtype']);
    const labelTag = `${typeCode}.${subtypeCode}`;
    const error = immCardModifyLimit.get('error')
    const success = immCardModifyLimit.get('success')
    const isFetching = immCardModifyLimit.get('isFetching')
    const initialDocumentsList = immCardModifyLimit.get('initialDocumentsList')
    const acceptedDocument = immHirePaymentMethod.get('acceptedDocument')
    const allDocumentRead = immCardModifyLimit.get('allDocumentRead')
    const [isCheckboxCheckedStep1, setIsCheckboxCheckedStep1] = useState(false);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [maxAmountDisabled, setMaxAmountDisabled] = useState(false);
    const [minimumlimit, setMinimumlimit] = useState();
    const [notLimit, setNotLimit] = useState(false);
    const documentPolicy = immCardModifyLimit.get('documentPolicy')
    const agreeIneCheckbox = immCardModifyLimit.get('agreeIneCheckbox')
    const nextButtonDisabledOffice = __CONTACT_CENTER__ && !isPrintOfficeMode() ? agreeIneCheckbox && documentPolicy :
        __CONTACT_CENTER__ && isPrintOfficeMode() ? immPrinter.get('documentsPrintedAndSigned') === YES_ACCEPTED : true
    const mappingBreadcrumb = [
        {
            text: formatText('breadcrumb-cards'),
            url: '/myprofile/cards'
        },
        {
            text: immCard.get('alias').get('current'),
            url: `/myprofile/cards/${cardId}/movements`
        },
        {
            text: formatText('cardDetails-limitLink')
        }
    ];
    const getCardType = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');
        const isVirtualCredit = immCard.get('isVirtualCredit');
        const isVanityCard = immCard.get('isVanityCard');
        const isNerudaCard = immCard.get('isNerudaCard');

        switch (true) {
            case isDiamond:
                return 'diamond';
            case isOpenCredit:
                return 'open-credit';
            case isPremium:
                return 'premium';
            case isViaT:
                return 'via-t';
            case isVirtualCredit:
                return 'virtual';
            case isVanityCard:
                return 'vanity';
            case isNerudaCard:
                return 'viajera';
            default:
                return 'open-credit';
        }
    };
    const getCardTypeHiring = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');
        const isVirtualCredit = immCard.get('isVirtualCredit');
        const isVanityCard = immCard.get('isVanityCard');
        const isNerudaCard = immCard.get('isNerudaCard');

        switch (true) {
            case isDiamond:
                return DIAMOND_CARD_PRODUCT_ALIAS_CC;
            case isOpenCredit:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
            case isPremium:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
            case isViaT:
                return VIA_T_CARD_PRODUCT_ALIAS_CC;
            case isVirtualCredit:
                return VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS_CC;
            case isVanityCard:
                return VANITY_CARD_PRODUCT_ALIAS_CC;
            case isNerudaCard:
                return NERUDA_CARD_PRODUCT_ALIAS_CC;
            default:
                return OPEN_CREDIT_PRODUCT_ALIAS_CC;
        }
    };
    useEffect(() => {
        const immCard = immCards.getIn(['byId', cardId]);
        const tagging = immCard.get('tagging');
        AccessHelper.allowAccess(cardConstants.CARD_MODIFY_LIMIT, { immCard }, history);
        requestLimits(cardId);
        recordPath('tarjeta/cambio-limite', PAGE_GENERIC, '', '', tagging);
    }, [])
    useEffect(() => {
        const cardType = getCardType()
        getNewCreditCardData(getCardData(cardType));
        __CONTACT_CENTER__ && !isPrintOfficeMode() && getHireInformation(getCardTypeHiring());
    }, []);
    useEffect(() => {
        return () => {
            clearRequest();
        };
    }, [clearRequest]);

    const buildConfirmationLabel = (labels) => {
        const labelElements = labels.map(item => {
            let element = <span key={item.text}><FormattedText value={item.text} /> </span>;
            const href = item.href;
            const url = hasTranslation(href) ? formatText(href) : href;

            if (url) {
                element = (
                    <OKLink
                        key={item.text}
                        id={item.id}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                        onClick={() => recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.text))}
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });
        return labelElements;
    }
    const precontractualConfirmationLabel = [
        {
            text: 'hireCreditCard-textInfoIneDir'
        },
        {
            text: 'hireCreditCard-textLinkInfoIneDir',
            href: 'hireCreditCard-linkInfoIneDir'
        },

    ]
    const getCardTypeName = () => {
        const isOpenCredit = immCard.get('isOpenCredit');
        const isDiamond = immCard.get('isDiamond');
        const isPremium = immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');

        switch (true) {
            case isDiamond:
                return getPlacementIdCard('diamond');
            case isOpenCredit:
                return getPlacementIdCard('open-credit');
            case isPremium:
                return getPlacementIdCard('premium');
            case isViaT:
                return getPlacementIdCard('via-t');
            default:
                return getPlacementIdCard('open-credit');
        }
    };

    const buildWizard = (immCard) => {
        const immSteps = immCardModifyLimit.get(__CONTACT_CENTER__ & !isPrintOfficeMode() ? 'stepsCC' : 'steps');
        const immStepOne = immSteps.get(FIRST_STEP);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: handleFinish,
            cancel: handleCancel
        };
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const visibleStep = immCardModifyLimit.get('visibleStep')
        const maximumLimitAuthorize = immHireCreditLimit.get('maximumLimitAuthorize');
        const creditLimit = immHireCreditLimit.get('creditLimit')
        const isLimitValid = maximumLimitAuthorize === NOT_MAX_LIMIT && creditLimit <= Number(minimumlimit) ? false : true
        const precontractualLabel = buildConfirmationLabel(precontractualConfirmationLabel)
        const ccDisabledButton = !isCheckboxChecked || creditLimit === immCard.getIn(['limit', 'amount'])
        const ccMaximumLimitAuthorizeCondition = __CONTACT_CENTER__ && !isPrintOfficeMode() && maximumLimitAuthorize && maximumLimitAuthorize !== NOT_MAX_LIMIT
        const commonSteps = [
            <WizardStep
                cancelButton={true}
                position="first"
                nextButtonDisabled={notLimit ? true : (isLimitValid ? (ccMaximumLimitAuthorizeCondition ? ccDisabledButton : maxAmountDisabled) : false)}
            >
                <ModifyNewLimitStep1
                    immCard={immCard}
                    immCardModifyLimit={immCardModifyLimit}
                    isCheckboxCheckedStep1={isCheckboxCheckedStep1}
                    setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
                    setIsCheckboxChecked={setIsCheckboxChecked}
                    isCheckboxChecked={isCheckboxChecked}
                    setMaxAmountDisabled={setMaxAmountDisabled}
                    minimumlimit={minimumlimit}
                    setMinimumlimit={setMinimumlimit}
                    setNotLimit={setNotLimit}
                    getCustomTags={getCustomTags}
                    pageName={PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT}
                />
            </WizardStep >,
            <WizardStep
                position="last"
                cancelButton={true}
                addLoadingBehaviour={true}
                immFinalButton="common-confirm"
                isLoading={immCardModifyLimit.get('isFetching')}
                finalButtonDisabled={!nextButtonDisabledOffice}
            >
                <ModifyNewLimitStep3
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    immCard={immCard}
                    contractName={immCard.get('contractName')}
                    immStepOne={immStepOne}
                    immCardModifyLimit={immCardModifyLimit}
                    showIneAndRevolving={showIneAndRevolving}
                    placementIdCard={getCardTypeName()}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    pageName={PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT}
                    getCustomTags={getCustomTags}
                />
            </WizardStep>

        ];
        const newSteps = (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 1),
            <WizardStep
                position="middle"
                cancelButton={true}
                nextButton={true}
                nextButtonDisabled={allDocumentRead}
            >
                <HireCardOpenCreditStepINEDIR
                    initialDocumentList={initialDocumentsList}
                    onSavedocumentAcceptance={documentRead}
                    acceptedDocument={acceptedDocument}
                    onAcceptAllDocument={onAcceptAllDocument}
                    precontractualLabel={precontractualLabel}
                    allDocumentRead={allDocumentRead}
                    saveDocumentList={saveDocumentList}
                    checkRadioButtonIneDir={checkRadioButtonIneDir}
                    pageName={PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT}
                />
            </WizardStep>,
            ...commonSteps.slice(1)
        ] : commonSteps;

        const tealiumData = [
            catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_1_VIEW]({ productName: labelTag}),
            catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_2_VIEW]({ productName: labelTag, amount: creditLimit }),
            catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_STEP_3_VIEW]({ productName: labelTag, amount: creditLimit }),
        ];

        const tealiumEvents = {
          cancel: catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_CANCEL]({ pageName: PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT }),
          finish: catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_WIZARD_FINISH]({ pageName: PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT }),
          next: catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_NEXT]({ pageName: PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT }),
          previous: catalogue[analyticsId.CARD_MODIFY_CREDIT_LIMIT_PREVIOUS]({ pageName: PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT })
        };

        return (
            <div className="col-xs-12">
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={immSteps.size}
                    visibleStep={visibleStep}
                    showPreLeaveModal={!immProfile.get('isNerudaUser')}
                    tealium={tealiumData[visibleStep - 1]}
                    tealiumEvents={tealiumEvents}
                    isTaggingSecondVersion
                >
                    {newSteps}
                </Wizard>
            </div>
        );
    }
    const handleCancel = () => {
        history.push(redirect);
    }

    const handleFinish = () => {
        modifyLimit(cardId);
    }

    const tutorial = (
        <TutorialLauncher
            type={GRAPHIC_TUTOR_TYPE_4}
            title={formatText('tutorials-cardsModifyLimitTitle')}
        />
    );
    return (
        <div>
            <div className="container-fluid card-movements--header-identifier">
                <div className="row">
                    <OKCover size="medium" section="cards" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            subtitleLeft={subtitleLeft}
                            subtitleRight={subtitleRight}
                            tutorial={tutorial}
                            finalTitle={getFinalTitle('cardModifyLimit-modifyCreditLimit')}>
                            <CardHeaderDetails immCard={immCard} />
                        </OKHeaderSubPage>
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        {isFetching ?
                            <LoadingSection />
                            : error ?
                                <ModifyLimitErrorStep
                                    url={redirect}
                                    buttonText={buttonText}
                                    immCard={immCard}
                                    immCardModifyLimit={immCardModifyLimit}
                                    immHireCreditLimit={immHireCreditLimit}
                                    getCustomTags={getCustomTags}
                                    pageName={PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT}
                                />
                                : success ?
                                    <ModifyLimitSuccessStep
                                        url={redirect}
                                        buttonText={buttonText}
                                        immCard={immCard}
                                        immCardModifyLimit={immCardModifyLimit}
                                        immHireCreditLimit={immHireCreditLimit}
                                        getCustomTags={getCustomTags}
                                        pageName={PAGE_NAME_CARD_MODIFY_CREDIT_LIMIT}
                                    />
                                    : buildWizard(immCard)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

module.exports.constructor = CardModifyNewLimitView;
module.exports.CardModifyNewLimitView = connect(
    (state, ownProps) => ({
        immCards: state.cards,
        immCardModifyLimit: state.cardModifyNewLimit,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immProfile: state.profile,
        immRevolvingPersistentData: state.revolvingPersistentData,
        redirect: ownProps.location.search.replace(/\?redirect=(.+)$/, "$1") || `/myprofile/cards/${ownProps.match.params.cardId}/details`,
        buttonText: ownProps.location.search.replace(/\?redirect=(.+)$/, "$1") && formatText("card-returnToDeferralPayments"),
        immHirePaymentMethod: state.hirePaymentMethod,
        immPrinter: state.printer,
        immHireCreditLimit: state.hireCreditLimit,

    }),
    {
        requestLimits: cardModifyNewLimitActions.requestLimits,
        validateStep: cardModifyNewLimitActions.validateStep,
        setVisibleStep: cardModifyNewLimitActions.setVisibleStep,
        setWillCancel: cardModifyNewLimitActions.setWillCancel,
        modifyLimit: cardModifyNewLimitActions.modifyLimit,
        clearRequest: cardModifyNewLimitActions.clearRequest,
        onHandleChangeCheckBoxCC: cardModifyNewLimitActions.onHandleChangeCheckBoxCC,
        handleAgreementCheckboxChange: cardModifyNewLimitActions.setAgreementCheckbox,
        getNewCreditCardData: cardModifyNewLimitActions.getNewCreditCardData,
        documentRead: hireNewCreditCardActions.documentRead,
        onAcceptAllDocument: hireNewCreditCardActions.onAcceptAllDocument,
        saveDocumentList: hireNewCreditCardActions.saveDocumentList,
        checkRadioButtonIneDir: hireNewCreditCardActions.checkRadioButtonIneDir,
        getHireInformation: hireInformationActions.getHireInformation,

    }
)(withRouter(CardModifyNewLimitView));




